import { Dispatch, FC, SetStateAction, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FormProvider, useForm } from 'react-hook-form'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { InputTextWrapper } from '../../../../../../components/UI/Form/Input'
import InputPasswordWrapper from '../../../../../../components/UI/Form/Input/passwordWrapper'
import { createCrewAssignment } from '../../../../services/crewAssignment.service'
import { login } from '../../../../../auth/services/login.service'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  onSuccess?: () => void
}

export const ModalAddCrew: FC<Props> = ({
  show,
  setShow,
  onSuccess,
}) => {
  const methods = useForm<any>({})
  const {
    handleSubmit,
    reset,
  } = methods
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const handleClose = () => {
    setShow(false)
    reset()
    setErrorMessage('')
  }

  const onSubmit = async (data: any) => {
    try {
      setLoading(true)
      setErrorMessage('')

      if (!data?.usuario || !data?.contraseña) {
        setErrorMessage('Por favor complete todos los campos')
        setLoading(false)
        return
      }

      const {
        data: response,
      } = await login(data.usuario, data.contraseña)

      if (response.error) {
        setErrorMessage(response.message || 'Las credenciales son incorrectas o el usuario no existe')
        setLoading(false)
        return
      }

      const obj = {
        userId: response.data.id,
      }
      const { data: res } = await createCrewAssignment(obj)

      if (!res.error) {
        handleClose()
        if (onSuccess) {
          onSuccess()
        }
      } else {
        setErrorMessage(res.message || 'Error al crear el usuario')
        setLoading(false)
      }
    } catch (error: any) {
      setLoading(false)

      if (error?.response?.status === 401 || error?.response?.status === 400) {
        const errorMsg = error?.response?.data?.message || error?.response?.data?.data?.message || 'Las credenciales son incorrectas o el usuario no existe'
        setErrorMessage(errorMsg)
      } else {
        setErrorMessage(error?.response?.data?.message || error?.response?.data?.data?.message || 'Error al procesar la solicitud')
      }
      console.error('Error al crear usuario:', error)
    }
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-mobile-top'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Agregar Usuario</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='d-flex row'>
                <div className='mb-2 col-sm-12'>
                  <InputTextWrapper
                    labelText='Usuario'
                    name='usuario'
                    textPlaceholder='Escribe el Usuario'
                    required
                    type='alphaNumeric'
                  />
                </div>
                <div className='mb-2 col-sm-12'>
                  <InputPasswordWrapper
                    labelText='Contraseña'
                    name='contraseña'
                    textPlaceholder='Escribe la Contraseña'
                    required
                    type='password'
                  />
                </div>
              </div>

              {errorMessage && (
                <div className='alert alert-danger d-flex align-items-center p-2 mb-3'>
                  <span>{errorMessage}</span>
                </div>
              )}
              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-sm btn-light-primary me-5'
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancelar
                </button>
                <button
                  type='submit'
                  className='btn btn-sm btn-primary'
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                      Procesando...
                    </>
                  ) : (
                    'Agregar'
                  )}
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}
